module.exports = __webpack_public_path__ + "img/terroir-spiral-3-mobile.70da212e.jpg";